export let fetchLivePosts = async (channel, page) => {
  let api = `https://api.scribblelive.com/v1/stream/${channel}/posts?PageNumber=${page}&PageSize=15&IncludeComments=false&PostData=false&IncludeTrackingPixel=false&IncludeReplies=false&token=C93GrHxu`;
  let res = await fetch(api);
  if (!res.ok) {
    const message = `En feil oppstod i Scribble Live posts feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};

export let getLatestTimeStamp = async (channel) => {
  let api = `https://api.scribblelive.com/v1/stream/${channel}/lastmodified?token=C93GrHxu`;
  let res = await fetch(api);
  if (!res.ok) {
    const message = `En feil oppstod i Scribble timestamp feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};

export let getRecentPosts = async (channel, timestamp) => {
  let api = `https://api.scribblelive.com/v1/stream/${channel}/posts/since?Timestamp=${timestamp}&IncludeStreamStatus=true&IncludeReplies=false&PostData=false&token=C93GrHxu`;
  let res = await fetch(api);
  if (!res.ok) {
    const message = `En feil oppstod i Scribble timestamp feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};

export const getInstagramData = async (instagram) => {
  let api = `https://graph.facebook.com/v10.0/instagram_oembed?url=${instagram}&omitscript=true&maxwidth=320&access_token=831337716926834|d5689ea8ea804776514e569fdf0e7cb6`;
  let res = await fetch(api);
  if (!res.ok) {
    const message = `En feil oppstod i instagram api: ${res.status}`;
    throw new Error(message);
  }
  return (await res.ok) ? res.json() : undefined;
};
